import { Checkbox, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import React from 'react';

import { SCOPE_LABELS } from '../../../../core/types/scopes';

export const scopeLabel = (scope) => SCOPE_LABELS[scope] || scope.replace(/_/g, ' ');

/** One scope row; the checkbox is named by its label so screen readers (and tests) can find it. */
export const ScopeCheckboxItem = ({ scope, checked, onChange, disabled }) => (
  <ListItem dense>
    <ListItemIcon>
      <Checkbox
        checked={checked}
        onChange={onChange}
        value={scope}
        disabled={disabled}
        inputProps={{ 'aria-label': scopeLabel(scope) }}
      />
    </ListItemIcon>
    <ListItemText primary={scopeLabel(scope)} />
  </ListItem>
);
